import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { PropertyLevelOffersCard } from '@shared-ui/lodging-property-offers';

import { UitkCard, UitkCardContentSection } from 'uitk-react-cards';
import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

const SingleOfferPropertyLevelOffersCardWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <ErrorBoundary label="PropertyLevelOffersCard">
    <UitkSpacing margin={{ large: { block: 'three', inlinestart: 'three' } }}>
      <UitkCard overflow={true}>
        <UitkCardContentSection padded={false}>
          <PropertyLevelOffersCard inputs={inputs} showBorder={false} skipSsr />
        </UitkCardContentSection>
      </UitkCard>
    </UitkSpacing>
  </ErrorBoundary>
);

SingleOfferPropertyLevelOffersCardWrapper.displayName = 'SingleOfferPropertyLevelOffersCardWrapper';
export const SharedUiSingleOfferPropertyLevelOffersCardWrapper = withSharedUiPropertyOffers(SingleOfferPropertyLevelOffersCardWrapper);
